import { ButtonType, DialogFooterButtonsWidget, TextLinkWidget } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss } from '~src/commonInfra/dialogs/ReactModalService';
import { DialogFieldParentStyle } from '~src/commonInfra/dialogs/style/DialogStyles';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { learnMoreStyle } from '~src/settings/styles/CommonStyles';

import { openGenerateKMSKeyDialog } from '../dialogs/KMSKeyGenerateDialog';


export interface KMSKeyMigrationViewProps {
    closeDialog: CloseAndDismiss;
}


export class KMSKeyMigrationView extends React.PureComponent<KMSKeyMigrationViewProps, {}> {

    constructor(props: KMSKeyMigrationViewProps) {
        super(props);
    }


    public render(): JSX.Element {
        return <>
            <div style={DialogFieldParentStyle}>
                <span>{Messages.extractEncryption_KMSKeyMigrationDialog_Warning()}
                <TextLinkWidget
                    testId={'kms-key-migration-learn-more'}
                    target={'_blank'}
                    href={HelpService.getHelpUrlByCategory('online-kms-external-switch')}
                    className={learnMoreStyle}>
                    {Messages.learnMore()}
                </TextLinkWidget>
                </span>
            </div>
            <div style={DialogFieldParentStyle}>
                {Messages.extractEncryption_KMSKeyMigrationDialog_Desc()}
            </div>
            <div style={DialogFieldParentStyle}>
                {Messages.extractEncryption_KMSKeyMigrationDialog_Confirmation()}
            </div>
            <div style={{ position: 'relative' }}>
                <DialogFooterButtonsWidget
                    buttons={[
                        {
                            buttonType: ButtonType.Outline,
                            children: Messages.cancel(),
                            onClick: this.props.closeDialog.close,
                            testId: 'cancel-button'
                        },
                        {
                            buttonType: ButtonType.Destructive,
                            children: Messages.extractEncryption_KMSKeyMigrationDialog_Migrate_button(),
                            onClick: () => {
                                openGenerateKMSKeyDialog(true, () => {});
                                this.props.closeDialog.close();
                            },
                            testId: 'migrate-button'
                        }
                    ]}
                />
            </div>
        </>;
    }
}